import * as React from "react";
import { IPinnedRowsRenderersComponentProps } from "../pinned-row-constants";
import { formatValueOnPlanAndTotalType } from "../pinned-row-helpers";

export const TotalsRenderersDoorColumn: React.FunctionComponent<IPinnedRowsRenderersComponentProps> = ({
    totalType,
    style,
    currency,
    total,
}) => {
    const value = formatValueOnPlanAndTotalType({ value: total, totalType, currency });

    return (
        <div style={style} className="planCell">
            <div className="actualValue">{value}</div>
        </div>
    );
};
